<template>
  <div>
    <p v-if="!showSignUpForm && !showResetForm && loginMessage" class="success-message">{{ loginMessage }}</p>
    <div v-if="!loggedIn" class="login-form" :class="{ shake: shakeScreen }">
      <h2 v-if="!showSignUpForm && !showResetForm">Sign In</h2>
      <DxForm ref="loginForm" v-if="!showSignUpForm && !showResetForm" :formData="loginData">
        <DxSimpleItem 
          dataField="email" 
          :editorOptions="{ 
            placeholder: 'john.doe@gmail.com',
            stylingMode: 'underlined',
            elementAttr: { 
              style: invalidLogin ? 'background-color: #ffcccc; border-bottom: 2px solid black; padding-left: 10px; margin-bottom: 10px;' : 'background-color: #f0f0f0; border-bottom: 2px solid black; padding-left: 10px; margin-bottom: 10px;' 
            } 
          }"
          :label="{ visible: false }" 
          :validationRules="[
          { type: 'required', message: 'Email is required' },
          { type: 'email', message: 'Email is invalid' },
          { 
            type: 'async', 
            validationCallback: (params) => {
              return this.checkEmailExists(params.value)
                .then(exists => {
                  console.log('Email exists:', exists); // Add logging here
                  return exists; // Return true if email exists
                })
                .catch(error => {
                  console.error('Error during email validation:', error);
                  return false;
                });
            },
            message: 'Email does NOT exists!'
          }
          ]"
        />
        <DxSimpleItem 
          dataField="password" 
          :editorOptions="{ 
            mode: 'password', 
            placeholder: 'pass123',
            stylingMode: 'underlined',
            elementAttr: { 
              style: invalidLogin ? 'background-color: #ffcccc; border-bottom: 2px solid black; padding-left: 10px; margin-bottom: 10px;' : 'background-color: #f0f0f0; border-bottom: 2px solid black; padding-left: 10px; margin-bottom: 10px;' 
            } 
          }"
          :label="{ visible: false }"
          :validationRules="[
          { type: 'required', message: 'Password is required' }
          ]" 
        />
        <DxButtonItem
          :buttonOptions="{
            width: '100%',
            text: 'Sign In',
            type: 'success',
            onClick: handleLogin
          }"
          class="form-button"
        />
        <DxButtonItem
          :buttonOptions="{
            width: '100%',
            text: 'Sign Up',
            type: 'default',
            onClick: handleSignUp
          }"
          class="form-button"
        />
      </DxForm>
      <div v-if="!showSignUpForm && !showResetForm" class="reset-link">
        <a href="#" @click.prevent="displayResetForm">Forgot Password?</a>
      </div>
      <SignUpForm v-else-if="showSignUpForm" @show-login-form="showLoginForm" />
      <PasswordResetForm v-else @show-login-form="showLoginForm" />
    </div>
    <ShowProducts v-else />
  </div>
</template>

<script>
import { DxForm, DxSimpleItem, DxButtonItem } from 'devextreme-vue/form';
import SignUpForm from './SignUpForm.vue';
import PasswordResetForm from './PasswordResetForm.vue';
import { EventBus } from '../eventBus';
import ShowProducts from './ShowProducts.vue';
import notify from 'devextreme/ui/notify';

export default {
  components: {
    DxForm,
    DxSimpleItem,
    DxButtonItem,
    SignUpForm,
    PasswordResetForm,
    ShowProducts
  },
  data() {
    return {
      loginData: {
        email: '',
        password: ''
      },
      showSignUpForm: false,
      showResetForm: false,
      shakeScreen: false,
      invalidLogin: false,
      loggedIn: false,
      loginMessage: ''
    };
  },
  created() {
    EventBus.on('show-login-form', this.showLoginForm);
    this.checkAuthToken();
  },
  methods: {
    async handleLogin() {
      const formInstance = this.$refs.loginForm?.instance;
      if (!formInstance) {
        console.error('Form instance is not available');
        return;
      }

      const result = await formInstance.validate();
      console.log('Validation result:', result);
      await result.complete; // Wait for all asynchronous validations to complete
      console.log('Validation complete:', result);
      if (result.isValid) {
        console.log('Form is valid, proceeding with login');
        try {
          const response = await fetch(`${process.env.VUE_APP_API_URL}/login.php`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.loginData)
          });
          const data = await response.json();
          console.log(data);
          if (data.success) {
            const expires = new Date(Date.now() + 5 * 60 * 1000).toUTCString();
            document.cookie = `username=${this.loginData.username}; expires=${expires}; path=/;`;
            //EventBus.emit('navigate', 'HelloWorld'); // Navigate to HelloWorld component
            this.invalidLogin = false;
            this.loggedIn = true;
          } else {
            notify('Invalid email or password!', 'error', 5000);
          }
        } catch (error) {
          console.error('Error logging in:', error);
          this.errorMessage = 'Error logging in';
          this.invalidLogin = true;
        }
      } else {
        console.log('Form is invalid, not proceeding with login');
      }
    },
    handleSignUp() {
      // Show the sign-up form
      this.showSignUpForm = true;
      this.showResetForm = false;
    },
    showLoginForm(message) {
      // Show the login form
      this.showSignUpForm = false;
      this.showResetForm = false;
      // console.log('Tole : ', message);
      this.loginMessage = message;

      // Hide the message after 5 seconds
      setTimeout(() => {
      this.loginMessage = '';
      }, 5000);
    },
    displayResetForm() {
      // Show the password reset form
      this.showResetForm = true;
      this.showSignUpForm = false;
    },
    async checkEmailExists(email) {
      try {
        const response = await fetch(`${process.env.VUE_APP_API_URL}/check_email.php`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ email })
        });
        const result = await response.json();
        console.log('API response exists:', result.exists); // Ensure this logs a boolean value
        return result.exists; // Ensure this returns true or false
      } catch (error) {
        console.error('Error during email validation:', error);
        return false; // Return false in case of an error
      }
    },
    checkAuthToken() {
      const cookieValue = document.cookie
        .split('; ')
        .find(row => row.startsWith('username='))
        ?.split('=')[1];
      if (cookieValue) {
        this.loggedIn = true;
      }
    }
  }
};
</script>

<style scoped>
.login-form {
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.1s ease-in-out;
}

.login-form h2 {
  color: var(--base-text-color);
  text-align: center;
  line-height: 24px;
  font-weight: 500;
  font-size: 24px;
  padding-bottom: 20px;
}

.login-form .dx-form .dx-field-item-content {
  margin-bottom: 20px;
}

.form-button {
  width: 100%;
  margin-top: 10px;
}

.reset-link {
  margin-top: 20px; /* Add margin to create a gap */
  text-align: center;
}

.reset-link a {
  color: #007bff;
  text-decoration: none;
}

.reset-link a:hover {
  text-decoration: underline;
}

.success-message {
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
  border-radius: 4px;
  color: #4caf50; /* Green color for success */
  background-color: #e8f5e9; /* Light green background */
  border: 1px solid #4caf50; /* Green border */
  margin-bottom: 15px;
  text-align: center;
  font-weight: bold;
}
</style>